// extracted by mini-css-extract-plugin
export default {"dialog":"NotesDialog_dialog__zPSjQ","dialogContentTitle":"NotesDialog_dialogContentTitle__ZtPO4","boldText":"NotesDialog_boldText__cfIvz","notes":"NotesDialog_notes__2f3l8"};